// extracted by mini-css-extract-plugin
export default {"button-wrapper":"_3lZEX","buttonWrapper":"_3lZEX","dot":"_2LI95"};